import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { setCalendarView } from "../../actions/calendarActions";
import * as Icon from "react-feather";

const Toolbar = (props) => {
  const { selectedView: calendarSelectedView } = props.calendar;

  /**
   * Get title for calendar date
   */
  const getCalendarDateTitle = () => {
    const { selectedView } = props.calendar;
    const { selectedDate, calendarFirstDay = 0 } = props;
    const weekMoment = (date) =>
      moment(date).locale("en", { week: { dow: calendarFirstDay } });

    switch (selectedView) {
      case "month":
        return moment(selectedDate).format("MMMM YYYY");
      case "week":
        const dated = weekMoment(selectedDate);
        return `${dated.startOf("week").format("MMM DD")} – ${dated
          .endOf("week")
          .format("MMM DD, YYYY")}`;
      case "day":
        return moment(selectedDate).format("MMMM D, YYYY");
      default:
        return "";
    }
  };

  const onBackHandler = () => {
    const { selectedView, onNavigate } = props.calendar;
    const { selectedDate, setSelectedDate } = props;
    switch (selectedView) {
      case "month":
        const dated = moment(selectedDate).subtract(1, "month");
        onNavigate(dated, "PREV");
        setSelectedDate(dated);
        break;
      case "week":
        const weekDated = moment(selectedDate).subtract(1, "week");
        onNavigate(weekDated, "PREV");
        setSelectedDate(weekDated);
        break;
      case "day":
        const dayDated = moment(selectedDate).subtract(1, "day");
        onNavigate(dayDated, "PREV");
        setSelectedDate(dayDated);
        break;
      default:
        break;
    }
  };

  const onNextHandler = () => {
    const { selectedView, onNavigate } = props.calendar;
    const { selectedDate, setSelectedDate } = props;
    switch (selectedView) {
      case "month":
        const dated = moment(selectedDate).add(1, "month");
        onNavigate(dated, "NEXT");
        setSelectedDate(dated);
        break;
      case "week":
        const weekDated = moment(selectedDate).add(1, "week");
        onNavigate(weekDated, "NEXT");
        setSelectedDate(weekDated);
        break;
      case "day":
        const dayDated = moment(selectedDate).add(1, "day");
        onNavigate(dayDated, "NEXT");
        setSelectedDate(dayDated);
        break;
      default:
        break;
    }
  };

  const onTodayHandler = () => {
    const { onNavigate } = props.calendar;
    const { currentDate, setSelectedDate } = props;
    onNavigate(currentDate, "TODAY");
    setSelectedDate(currentDate);
  };

  return (
    <div className="toolbar">
      {/* Left: navigation */}
      <div className="toolbar__nav">
        <button
          className="btn btn_month"
          onClick={onBackHandler}
          type="button"
          aria-label="Previous"
          title="Previous"
        >
          <Icon.ChevronLeft size="22" strokeWidth={2} />
        </button>
        <h3 className="toolbar__title" aria-live="polite">{getCalendarDateTitle()}</h3>
        <button
          className="btn btn_month"
          onClick={onNextHandler}
          type="button"
          aria-label="Next"
          title="Next"
        >
          <Icon.ChevronRight size="22" strokeWidth={2} />
        </button>
      </div>

      {/* Right: today + view toggle */}
      <div className="toolbar__right">
        <button
          className="btn toolbar__today-btn calendar_view"
          onClick={onTodayHandler}
          type="button"
        >
          Today
        </button>

        <div className="d-flex calendar_view toolbar__views">
          {props.calendar.views.includes("month") && (
            <button
              className={`btn ${calendarSelectedView === "month" ? "active" : ""}`}
              onClick={() => props.setCalendarView("month")}
              type="button"
            >
              Month
            </button>
          )}
          {props.calendar.views.includes("week") && (
            <button
              className={`btn ${calendarSelectedView === "week" ? "active" : ""}`}
              onClick={() => props.setCalendarView("week")}
              type="button"
            >
              Week
            </button>
          )}
          {props.calendar.views.includes("day") && (
            <button
              className={`btn ${calendarSelectedView === "day" ? "active" : ""}`}
              onClick={() => props.setCalendarView("day")}
              type="button"
            >
              Day
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendar: state.calendar,
});

export default connect(mapStateToProps, {
  setCalendarView,
})(Toolbar);
